import type { WorkflowCapabilities } from '@jira/project-settings__workflow-types/src/workflowTypes.types.tsx';
import {
	createResource,
	useResource,
	type ResourceStoreContext,
	type RouterDataContext,
	type RouteResource,
	type UseResourceHookResponse,
} from '@atlassian/react-resource-router';
import { fetchWorkflowCapabilities } from './fetchWorkflowCapabilities.tsx';

export const RESOURCE_TYPE_KEY = 'ADMIN_WORKFLOW_CAPABILITIES';

export const workflowCapabilitiesResource: RouteResource<WorkflowCapabilities> =
	createResource<WorkflowCapabilities>({
		type: RESOURCE_TYPE_KEY,
		getKey: (matchedRoute) => {
			const { workflowId, projectKey, issueTypeId } = matchedRoute.match.params;
			if (workflowId) {
				return `${RESOURCE_TYPE_KEY}_${workflowId}`;
			}
			return `${RESOURCE_TYPE_KEY}_${projectKey}_${issueTypeId}`;
		},
		getData: async (routerContext: RouterDataContext, customContext: ResourceStoreContext) =>
			fetchWorkflowCapabilities(routerContext, customContext),
		maxAge: 0,
		isBrowserOnly: true,
	});

export const useWorkflowCapabilities = (): UseResourceHookResponse<WorkflowCapabilities> =>
	useResource<WorkflowCapabilities>(workflowCapabilitiesResource);
